// extracted by mini-css-extract-plugin
module.exports = {"instagramWrapper":"Mj","innerTile":"Nj","heading":"Oj","instaTileBtn":"Pj","disabled":"Qj","instaTileElement":"Rj","instagramPic":"Sj"};